import React from 'react';

import Table from '@/components/ui/tables/Table';
import { FilterDropdown } from '@/components/ui/filters/FilterDropdown';
import { ExportDropdown } from '@/components/ui/filters';
import { useAssignedEmployeesList, useAssignedEmployeesExport } from '@/hooks/securityGrouping';


export const AssignedEmployeesTab: React.FC = () => {
  const {
    rows,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    filters,
    setFilters,
    filterConfig,
    columns,
    actions,
    onSearch,
    onSortChange,
    loading,
    canView,
  } = useAssignedEmployeesList();

  const { exportAssignedEmployees, isExporting } = useAssignedEmployeesExport({
    status: filters.status,
  });

  return (
    <div className="flex flex-col gap-6" data-testid="assigned-employees-tab">
      <div className="flex justify-between items-start">
        <div className="flex flex-wrap gap-4">
          <FilterDropdown
            filters={filterConfig}
            values={{
              status: filters.status,
            }}
            onChangeFilter={(key, value) => {
              setFilters((previous) => ({
                ...previous,
                [key]: value,
              }));
            }}
          />
        </div>
        {canView && (
          <ExportDropdown
            onExport={exportAssignedEmployees}
            placement="right"
            isLoading={isExporting}
            availableFormats={['EXCEL']}
          />
        )}
      </div>

      <Table
        columns={columns}
        actions={actions}
        data={rows}
        totalRows={total}
        searchable
        onSearch={onSearch}
        onSortChange={onSortChange}
        serverSideSort
        columnMaxWidth={150}
        pagination={{
          page,
          pageSize,
          total,
          onChange: setPage,
          onPageSizeChange: setPageSize,
        }}
        data-testid="assigned-employees-table"
        isLoading={loading}
      />
    </div>
  );
};

export default AssignedEmployeesTab;
